if (!customElements.get('add-on')) {
  customElements.define(
    'add-on',
    class AddOn extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
        this.debug = false;
        this.variantChangeUnsubscriber = undefined;
        this.observer = null;
        if (this.debug) console.log('AddOn constructor');
        this.dropdowns = this.querySelectorAll('.addOnProduct-dropdown');
        this.addOns = this.querySelectorAll('.addOnProduct');
        // Bind the method to the instance
        // this.swapVariantImg = this.swapVariantImg.bind(this);
        this.closeAllDropdowns();
        // Assign the function to the window object for global access
        // window.swapVariantImg = this.swapVariantImg;
        this.updateHiddenInputsToForm = this.updateHiddenInputsToForm.bind(this);
        window.updateHiddenInputsToForm = this.updateHiddenInputsToForm;
        this.setupObserver();
      }
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        if (this.debug) console.log('AddOn connectedCallback');
        // swapVariantImg();
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (this.debug) console.log('Variant changed:', event.data.variant.id);
          // reset summary items for addon
          this.resetAddonsSummary();
          // need to resetup the observer
          if (this.observer) {
            this.observer.disconnect(); // Disconnect the existing observer
          }
          this.setupObserver();
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      // Function to set up the MutationObserver
      setupObserver() {
        if (this.debug) console.log('setupObserver()');

        const addOnContainer = document.querySelector('add-on');

        // Attach listeners to initially loaded pagination elements
        const initialaddOnProduct = this.querySelectorAll('.addOnProduct'); // Adjust the selector as needed
        // this.attachAddOnDropdownListeners(initialaddOnProduct);
        this.attachAddOnCheckboxListeners(initialaddOnProduct);
        // swapVariantImg();
        updateHiddenInputsToForm();

        // now we attach listeners to any new pagination elements that are added
        this.observer = new MutationObserver((mutationsList) => {
          for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
              // Find newly added pagination elements
              const newAddOnElements = mutation.addedNodes;
              newAddOnElements.forEach((node, index) => {
                if (node.nodeType === Node.ELEMENT_NODE && node.matches('.addOnProduct')) {
                  // Adjust the selector as needed
                  // this.attachAddOnDropdownListeners([node]);
                  this.attachAddOnCheckboxListeners([node]);
                  // swapVariantImg();
                }
              });
              updateHiddenInputsToForm();
              window.swapPriceAll();
            }
          }
        });

        this.observer.observe(addOnContainer, { childList: true, subtree: true });
      }

      updateAddonsSummary(product, index) {
        const addonTitle = product.getAttribute('data-addon-cart-title');
        const selectedAddon = product.getAttribute('data-id');
        const productHasDropDown = product.hasAttribute('data-has-dropdown');
        let selectedAddonInfo;

        if (productHasDropDown) {
          selectedAddonInfo =
            product.querySelector(`div[data-variant-id="${selectedAddon}"]`)?.getAttribute('data-value') || '';
        } else {
          selectedAddonInfo = product.querySelector('[data-addon-details]')?.getAttribute('data-addon-details') || '';
        }

        const addonDetails = [selectedAddonInfo].filter(Boolean).join(' | ');

        setSummaryItem(`[data-summary-addon-${index + 1}]`, addonTitle, addonDetails);
      }

      resetAddonsSummary() {
        const totalAddonsNumberEl = document.querySelector('[data-total-addons-number]');
        const totalAddonsNumber = totalAddonsNumberEl
          ? Number(totalAddonsNumberEl.getAttribute('data-total-addons-number'))
          : 0;

        for (let i = 1; i <= totalAddonsNumber; i++) {
          setSummaryItem(`[data-summary-addon-${i}]`, '', '');
        }
      }

      attachAddOnDropdownListeners(add_on_products) {
        if (this.debug) console.log('attachAddOnDropdownListeners()');
        const self = this;

        add_on_products.forEach((add_on_product, index) => {
          if (this.debug) console.log('add on product:', add_on_product);
          // if dropdown has both a button and an option
          const button = add_on_product.querySelector('.addOnProduct-dropdown-button');
          if (this.debug) console.log('Button:', button);
          const options = add_on_product.querySelector('.addOnProduct-dropdown-options');
          if (this.debug) console.log('Options:', options);
          const selectedCopy = add_on_product.querySelector('[data-selected-dropdown-copy]');
          if (button && options) {
            button.addEventListener('click', function (event) {
              if (this.debug) console.log('Dropdown clicked');
              // Prevent default action to avoid conflicts
              event.stopPropagation();
              // Close other dropdowns
              const dropdowns = document.querySelectorAll('.addOnProduct-dropdown');
              dropdowns.forEach((dropdown) => {
                const otherButton = dropdown.querySelector('.addOnProduct-dropdown-button');
                const otherOptions = dropdown.querySelector('.addOnProduct-dropdown-options');
                if (otherButton && otherOptions && otherButton !== button) {
                  otherButton.classList.remove('dropdown-open');
                  otherOptions.classList.remove('is-visible');
                }
              });
              // Toggle the classes on the current dropdown
              button.classList.toggle('dropdown-open');
              options.classList.toggle('is-visible');
            });
            options.querySelectorAll('.addOnProduct-dropdown-option').forEach((option) => {
              if (this.debug) console.log('Dropdown option:', option);

              if (option.getAttribute('data-variant-available') === 'false') return;

              option.addEventListener('click', function (event) {
                // Prevent default action to avoid conflicts
                event.stopPropagation();
                // Remove 'tw-hidden' class from all options
                options.querySelectorAll('.addOnProduct-dropdown-option').forEach((opt) => {
                  opt.classList.remove('tw-hidden');
                });

                const dropdowns = document.querySelectorAll('.addOnProduct-dropdown');
                dropdowns.forEach((dropdown) => {
                  const otherButton = dropdown.querySelector('.addOnProduct-dropdown-button');
                  const otherOptions = dropdown.querySelector('.addOnProduct-dropdown-options');
                  otherButton.classList.remove('dropdown-open');
                  otherOptions.classList.remove('is-visible');
                });
                // Add 'tw-hidden' class to the selected option
                //this.classList.add('tw-hidden');
                // Get values from the selected option
                const title = this.querySelector('.addOnProduct-dropdown-option-title').textContent;
                console.log(title);
                const price = this.querySelector('.addOnProduct-dropdown-option-price').textContent;
                const formattedPrice = price.includes('Sold out')
                  ? price.replace(
                      'Sold out',
                      '<span class="sold_out tw-text-14px tw-font-normal tw-text-black tw-ml-5px">Sold out</span>'
                    )
                  : price;
                const formattedPriceAttr = price.replace(/(\d+)([^\d])/g, '$1 $2');
                const variantId = this.getAttribute('data-variant-id');
                // const parent element is the .addOnProduct
                const parentEl = this.closest('.addOnProduct');
                parentEl.setAttribute('data-id', variantId);
                parentEl.setAttribute('data-price', formattedPriceAttr);
                const textBeforePipe = title.split('|')[0].trim();
                const textAfterPipe = title.split('|')[1].trim();
                if (selectedCopy) {
                  const selectedTitle = selectedCopy.querySelector('.addOnProduct-dropdown-option-title');
                  const selectedPrice = selectedCopy.querySelector('.addOnProduct-dropdown-option-price');
                  if (selectedTitle) selectedTitle.textContent = textBeforePipe + ' | ' + textAfterPipe;
                  if (selectedPrice) selectedPrice.innerHTML = formattedPrice;
                }

                const foundImg = parentEl.querySelector(
                  `.addOnProduct-image-variant[data-variant-option2="${textBeforePipe}"]`
                );
                parentEl.querySelectorAll('.addOnProduct-image-variant').forEach((img) => {
                  img.classList.add('tw-hidden');
                });
                foundImg.classList.remove('tw-hidden');
                const thisAvailable = Boolean(foundImg.getAttribute('data-variant-available'));
                if (thisAvailable) {
                  parentEl.classList.remove('sold-out');
                } else {
                  parentEl.classList.add('sold-out');
                }
                button.classList.remove('dropdown-open');
                options.classList.remove('is-visible');
              });
            });
          }
        });
      }

      attachAddOnCheckboxListeners(add_on_products) {
        if (this.debug) console.log('attachAddOnCheckboxListeners()');
        // save reference to current instance
        const self = this;

        add_on_products.forEach((add_on_product, index) => {
          // Find the element with the class .addOnProduct-checkbox within each .addOnProduct
          const checkbox = add_on_product.querySelector('.addOnProduct-checkbox');
          // Find the sibling element with the class .addOnProduct__quantity-container
          const quantityContainer = add_on_product.querySelector('.addOnProduct__quantity-container');
          // Find all buttons inside .addOnProduct__quantity-container
          const quantityButtons = quantityContainer ? quantityContainer.querySelectorAll('.Quantity__button') : [];
          // Find the button with the class .Quantity__button--left inside .addOnProduct__quantity-container
          const buttonLeft = quantityContainer ? quantityContainer.querySelector('.Quantity__button--left') : null;
          const buttonRight = quantityContainer ? quantityContainer.querySelector('.Quantity__button--right') : null;
          const plusButton = add_on_product.querySelector('.addOnProduct-checkbox .plus');
          const visibleMinusButton = add_on_product.querySelector('[data-visible-minus-btn]');

          if (checkbox && quantityContainer) {
            // Add click event to the checkbox
            add_on_product.addEventListener('click', () => {
              const input = quantityContainer.querySelector('.Quantity__input');
              if (!input) return;

              const currentValue = parseInt(input.value, 10);
              const isZero = currentValue === 0;

              updateQuantityAndStyles(isZero);
              updateSummary(isZero, add_on_product, index);
            });
          }

          /**
           * Updates the quantity and toggles visibility of buttons and elements based on the current state.
           *
           * @param {boolean} isZero - Indicates whether the current value is zero.
           */
          function updateQuantityAndStyles(isZero) {
            if (isZero) {
              handleQuantityButtonClick(buttonRight);
              toggleVisibility(checkbox, visibleMinusButton, true);
            } else {
              handleQuantityButtonClick(buttonLeft);
              toggleVisibility(checkbox, visibleMinusButton, false);
            }
          }

          /**
           * Toggles the visibility of two elements based on the specified state.
           *
           * @param {HTMLElement} elementToHide - Element to be hidden when visibility is toggled.
           * @param {HTMLElement} elementToShow - Element to be shown when visibility is toggled.
           * @param {boolean} isVisible - Indicates whether to show or hide the elements.
           *                              True to show `elementToShow` and hide `elementToHide`,
           *                              and false to reverse the visibility.
           */
          function toggleVisibility(elementToHide, elementToShow, isVisible) {
            if (isVisible) {
              elementToHide.classList.add('tw-z-[-1]');
              elementToShow.classList.remove('tw-z-[-1]');
            } else {
              elementToHide.classList.remove('tw-z-[-1]');
              elementToShow.classList.add('tw-z-[-1]');
            }
          }

          /**
           * Updates the summary for add-ons based on the current quantity state.
           *
           * @param {boolean} isZero - Indicates if the quantity is zero. If true, the add-on's
           *                           summary is updated via `updateAddonsSummary`.
           * @param {HTMLElement} product - The product element for which the summary is being updated.
           * @param {number} index - The index of the product in the add-on list, used to target
           *                         specific summary elements.
           */
          function updateSummary(isZero, product, index) {
            if (isZero) {
              self.updateAddonsSummary(product, index);
            } else {
              setSummaryItem(`[data-summary-addon-${index + 1}]`, '', '');
            }
          }

          const handleQuantityButtonClick = (button) => {
            // Find the input inside .addOnProduct__quantity-container
            const input = quantityContainer.querySelector('.Quantity__input');
            let currentValue = parseInt(input.value, 10);

            // const currentVariant = add_on_product.querySelector('.addOnProduct-image-variant:not(.tw-hidden)');

            const currentVariantLimit = Number(add_on_product.getAttribute('data-available'));

            const maxValue = input.hasAttribute('max') ? parseInt(input.getAttribute('max')) : 9999;

            // Increase or decrease the input value depending on the button class
            if (
              button.classList.contains('Quantity__button--right') &&
              currentValue < currentVariantLimit &&
              currentValue < maxValue
            ) {
              input.value = currentValue + 1;
            } else if (button.classList.contains('Quantity__button--left')) {
              input.value = Math.max(0, currentValue - 1); // Prevents the value from being less than 0
            }

            updatePlusButton(parseInt(input.value, 10));

            updateHiddenInputsToForm();

            window.swapPriceAll();
          };

          const updatePlusButton = (value) => {
            if (plusButton) {
              if (value > 0) {
                plusButton.classList.add('active');
              } else {
                plusButton.classList.remove('active');
              }
            }
          };

          // Add click handler to buttons only once
          quantityButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
              // Using debounce and calling with button context
              debounce(() => {
                handleQuantityButtonClick(button);
              }, 300)();
            });
          });
        });
      }

      clearHiddenInputsToForm = () => {
        if (this.debug) console.log('clearHiddenInputsToForm()');
        return new Promise((resolve, reject) => {
          const form = document.querySelector('form[data-type="add-to-cart-form"]');
          if (!form) {
            console.error('Form with data-type="add-to-cart-form" not found.');
            return reject(new Error('Form not found'));
          }

          // Clear previous hidden inputs
          const hiddenInputs = form.querySelectorAll('.pdp_addons');
          hiddenInputs.forEach((input) => input.remove());

          if (this.debug) console.log('Previous hidden inputs cleared.');
          resolve();
        });
      };

      addHiddenInputsToForm = () => {
        if (this.debug) console.log('addHiddenInputsToForm()');
        const form = document.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) {
          console.error('Form with data-type="add-to-cart-form" not found.');
          return;
        }

        const fragment = document.createDocumentFragment(); // Use DocumentFragment for performance
        document.querySelectorAll('.addOnProduct').forEach((product, index) => {
          const id = product.getAttribute('data-id');
          const qtyInput = product.querySelector('.Quantity__input');
          const qty = qtyInput ? qtyInput.value : '0';

          if (id) {
            const inputId = document.createElement('input');
            inputId.type = 'hidden';
            inputId.name = `items[${index}][id]`;
            inputId.className = 'pdp_addons';
            inputId.value = id;

            const inputQty = document.createElement('input');
            inputQty.type = 'hidden';
            inputQty.name = `items[${index}][quantity]`;
            inputQty.className = 'pdp_addons';
            inputQty.value = qty;

            // Append inputs to the fragment
            fragment.appendChild(inputId);
            fragment.appendChild(inputQty);
          }
        });

        // Append all inputs to the form at once
        form.appendChild(fragment);
        if (this.debug) console.log('New hidden inputs added to form.');
      };

      updateHiddenInputsToForm() {
        if (this.debug) console.log('updateHiddenInputsToForm() called');

        // Optionally use a flag to prevent duplicate calls
        if (this.isUpdating) return; // Prevents multiple calls
        this.isUpdating = true; // Set the flag

        this.clearHiddenInputsToForm()
          .then(() => {
            this.addHiddenInputsToForm();
            this.isUpdating = false; // Reset the flag after completion
          })
          .catch((error) => {
            console.error('Error updating hidden inputs:', error);
            this.isUpdating = false; // Reset the flag on error
          });
      }

      // swapVariantImg = function () {
      //   if (this.debug) console.log('swapVariantImg()');
      //   const addOnProducts = document.querySelectorAll('.addOnProduct');
      //
      //   const checkedRadio = document.querySelector('.ProductOption__variants.type-finish input[type="radio"]:checked');
      //
      //   addOnProducts.forEach((prod) => {
      //     const found = checkedRadio
      //       ? prod.querySelector(
      //         `.addOnProduct .addOnProduct-image-variant[data-variant-option2="${checkedRadio.value}"]`
      //       )
      //       : null;
      //
      //     //clear all variants
      //     prod.querySelector('.plus').classList.remove('active');
      //     // prod.querySelector('.plus').innerHTML = '';
      //
      //     prod.querySelector('.Quantity__input').value = 0;
      //
      //     if (found != null) {
      //       const imageVariants = prod.querySelectorAll('.addOnProduct-image-variant');
      //       imageVariants.forEach((variant) => {
      //         variant.classList.add('tw-hidden');
      //       });
      //
      //       const thisVariantId = found.getAttribute('data-variant-id');
      //       const thisVariantPrice = found.getAttribute('data-variant-price');
      //       const thisAvailable = Boolean(found.getAttribute('data-variant-available'));
      //
      //       if (thisAvailable) {
      //         prod.classList.remove('sold-out');
      //       } else {
      //         prod.classList.add('sold-out');
      //       }
      //
      //       prod.setAttribute('data-price', thisVariantPrice);
      //
      //       prod.setAttribute('data-id', thisVariantId);
      //       prod.querySelector('.addOnProduct-gridName2').innerHTML = checkedRadio.value;
      //       prod.querySelector('.addOnProduct-price').innerHTML = thisVariantPrice;
      //       found.classList.remove('tw-hidden');
      //     }
      //   });
      // };

      closeAllDropdowns = () => {
        if (this.debug) console.log('closeAllDropdowns()');
        // Close all dropdowns when clicking outside
        document.addEventListener('click', (event) => {
          const dropdowns = document.querySelectorAll('.addOnProduct-dropdown');
          dropdowns.forEach((dropdown) => {
            const button = dropdown.querySelector('.addOnProduct-dropdown-button');
            const options = dropdown.querySelector('.addOnProduct-dropdown-options');
            if (button && options) {
              button.classList.remove('dropdown-open');
              options.classList.remove('is-visible');
            }
          });
        });
      };
    }
  );
}
